import React from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { Flex, Text } from "@radix-ui/themes";

interface DropdownMenuItem {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
}

interface DropdownMenuProps {
  items: DropdownMenuItem[];
  side?: "top" | "bottom" | "left" | "right";
  align?: "start" | "center" | "end";
}

export function DropdownMenu({
  items,
  side = "bottom",
  align = "end",
  children,
}: React.PropsWithChildren<DropdownMenuProps>) {
  return (
    <DropdownMenuPrimitive.Root>
      <DropdownMenuPrimitive.Trigger asChild>
        {children}
      </DropdownMenuPrimitive.Trigger>

      <DropdownMenuPrimitive.Content
        className="qc-Chat__DropdownMenu__Content"
        sideOffset={4}
        align={align}
        side={side}
        style={{ zIndex: 1 }}
      >
        {items.map((item) => (
          <DropdownMenuPrimitive.Item
            className="qc-Chat__DropdownMenu__Item"
            onClick={item.onClick}
          >
            <Flex align={"center"} gap={"2"}>
              {item.icon}

              <Text size={"2"} highContrast>
                {item.label}
              </Text>
            </Flex>
          </DropdownMenuPrimitive.Item>
        ))}
      </DropdownMenuPrimitive.Content>
    </DropdownMenuPrimitive.Root>
  );
}
